import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AdapterClass;
function Adapter() {
  if (AdapterClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Adapter');
    AdapterClass = $;
  }
  return AdapterClass;
}
//region block: exports
export {
  Adapter as Adapter1t72m9xaryzfb,
};
//endregion

//# sourceMappingURL=Adapter.mjs.map
